export const SOCIAL_HISTORY_FIELDS = [
  { key: "relationship", label: "Relationship" },
  { key: "hasChildren", label: "Has Children" },
  { key: "numberOfChildren", label: "Number of children" },
  { key: "agesOfChildren", label: "Ages of children" },
  { key: "tobaccoUse", label: "Tobacco Use" },
  { key: "alcoholUse", label: "Alcohol Use" },
  { key: "cannabisOrDrugUse", label: "Cannabis or Drug Use" },
  { key: "caffeineUse", label: "Caffeine Use" },
  { key: "sleepHours", label: "Sleep Hours" },
  { key: "sleepQuality", label: "Sleep Quality" },
  { key: "sleepTrouble", label: "Sleep Trouble" },
  { key: "physicalActivityFrequency", label: "Physical Activity Frequency" },
  { key: "physicalActivityType", label: "Physical Activity Type" },
  {
    key: "physicalActivityMinutesPerSession",
    label: "Physical Activity Minutes Per Session",
  },
  { key: "stressLevel", label: "Stress Level" },
  { key: "stressSource", label: "Stress Source" },
  { key: "stressCopingMethods", label: "Stress Coping Methods" },
  { key: "hasSupportSystem", label: "Has Support System" },
  { key: "additionalInformation", label: "Additional Information" },
];
